import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Badge, User } from "@ecologi/shared";

import styles from "../styles/AchievementBadge.module.scss";

const BadgeWrapper = styled.div<{ isNoPadding?: boolean }>`
  ${(props) =>
    props.isNoPadding &&
    css`
      padding: 0;
    `}
`;

export type AchievementBadgeProps = {
  badge: Badge;
  setAchievementPopupBadge?: (badge: Badge) => void;
  user: User | null;
  isStatic?: boolean;
  isTitleHidden?: boolean;
  size?: number;
  isNoPadding?: boolean;
};

export const AchievementBadge = ({
  badge,
  setAchievementPopupBadge,
  user,
  isStatic,
  isTitleHidden,
  size,
  isNoPadding,
}: AchievementBadgeProps) => {
  if (!user) {
    return <div />;
  }

  return (
    <BadgeWrapper className={styles.achievementBadge} isNoPadding={isNoPadding}>
      <button
        className={styles.achievementBadgeButton}
        style={size ? { width: `${size}px`, height: `${size}px` } : {}}
        data-badge-category={badge.category}
        data-badge-id={badge.id}
        data-complete={user.isBadgeComplete(badge.id)}
        data-static={isStatic}
        onClick={(e) => {
          e.currentTarget.blur();
          if (isStatic || !setAchievementPopupBadge) {
            return;
          }
          setAchievementPopupBadge(badge);
        }}
        type="button"
      />
      {!isTitleHidden && <>{badge.title}</>}
    </BadgeWrapper>
  );
};
